import clsx from 'clsx'

import { List } from '@tribeplatform/react-ui-kit/Layout'
import { Modal } from '@tribeplatform/react-ui-kit/Modal'

import { emailStatusMapping } from './constants'

export const EmailStatusModal = ({
  open,
  onClose,
}: {
  open: boolean
  onClose: () => void
}) => {
  return (
    <Modal open={open} onClose={onClose} size="2xl">
      <Modal.Header title="Email status guide" />
      <Modal.Content>
        <List className="list-disc list-outside px-5">
          {Object.keys(emailStatusMapping).map(status => {
            const emailStatus = emailStatusMapping[status]

            return (
              <List.Item key={status}>
                <span className={clsx('font-medium', emailStatus.className)}>
                  {emailStatus.title}:
                </span>{' '}
                {emailStatus.description}.
              </List.Item>
            )
          })}
        </List>
      </Modal.Content>
    </Modal>
  )
}
